const PARIS_TZ = 'Europe/Paris'

export function shouldShowWeekendBanner(summary: {
  fareValidityDeadline?: string
  ticketingDeadline?: string
}): boolean {
  if (!isWeekendAlertWindow()) return false

  const ld = summary.ticketingDeadline
  const opw = summary.fareValidityDeadline

  return (ld != null && isDeadlineOnWeekend(ld)) || (opw != null && isDeadlineOnWeekend(opw))
}

function getParisDay(date: Date): number {
  const dayStr = new Intl.DateTimeFormat('en-US', {
    timeZone: PARIS_TZ,
    weekday: 'short',
  }).format(date)

  const dayMap: Record<string, number> = {
    Fri: 5,
    Mon: 1,
    Sat: 6,
    Sun: 0,
    Thu: 4,
    Tue: 2,
    Wed: 3,
  }

  return dayMap[dayStr] ?? -1
}

function getParisHourMinute(date: Date): { hours: number; minutes: number } {
  const parts = new Intl.DateTimeFormat('en-US', {
    hour: 'numeric',
    hour12: false,
    minute: 'numeric',
    timeZone: PARIS_TZ,
  }).formatToParts(date)

  const hours = Number(parts.find((p) => p.type === 'hour')?.value ?? 0)
  const minutes = Number(parts.find((p) => p.type === 'minute')?.value ?? 0)
  return { hours, minutes }
}

function isDeadlineOnWeekend(deadlineIso: string): boolean {
  const date = new Date(deadlineIso)
  const day = getParisDay(date)
  return day === 0 || day === 6
}

function isWeekendAlertWindow(now: Date = new Date()): boolean {
  const day = getParisDay(now)

  if (day === 0) return true
  if (day === 6) {
    const { hours, minutes } = getParisHourMinute(now)
    return hours > 11 || (hours === 11 && minutes >= 30)
  }
  return false
}
